import { DesignSourceEnum } from '@insights/insights-data-provider';

export const parseVpcSource = (value?: string | null) => ({
  sourceValue: value as DesignSourceEnum,
  fromSms: value === DesignSourceEnum.sms,
  fromEmail: value === DesignSourceEnum.email,
  fromGallery: value === DesignSourceEnum.gallery,
  fromGuide: value === DesignSourceEnum.recommendation,
  fromSpr: value === DesignSourceEnum.spr,
  fromQr: value === DesignSourceEnum.qr,
  fromSkytta: value === DesignSourceEnum.skytta,
  fromCode: value === DesignSourceEnum.enterCode,
  fromMessage: value === DesignSourceEnum.sms || value === DesignSourceEnum.email,
  validSource: Object.values(DesignSourceEnum).includes(value as DesignSourceEnum)
});

export const getVpcSource = (query: URLSearchParams) => parseVpcSource(query.get('vpcSource'));
